import { render, staticRenderFns } from "./AddProjectDeliverable.vue?vue&type=template&id=49110464&"
import script from "./AddProjectDeliverable.vue?vue&type=script&lang=js&"
export * from "./AddProjectDeliverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports